<div class="modal-wrapper">
  <div class="wrapper">
    <p i18n>Используемая вами версия приложения устарела. Для продолжения работы необходимо обновить
    страницу</p>
    <div class="btns">
      <button (click)="reloadPage()" mat-raised-button color="primary" i18n>Обновить</button>
      <button *ngIf="!params?.force" (click)="cancel()" mat-raised-button i18n>Отмена</button>
    </div>
  </div>
</div>
